module.exports = __webpack_public_path__ + "img/article_6_1.4064e283.png";